var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-create-ubl-archive-modal-wrapper",
    {
      on: {
        close: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c(
        "w-card-content",
        [
          _vm.browseState.selectedItems.length === 0
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-date-picker", {
                        attrs: { label: _vm.$ct("begin-date"), fancy: "" },
                        model: {
                          value: _vm.beginDate,
                          callback: function ($$v) {
                            _vm.beginDate = $$v
                          },
                          expression: "beginDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-date-picker", {
                        attrs: { label: _vm.$ct("end-date"), fancy: "" },
                        model: {
                          value: _vm.endDate,
                          callback: function ($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-row",
                { staticClass: "mb" },
                [
                  _c("w-col", { attrs: { xs: "12", md: "12" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$ct("selected-items", {
                          count: _vm.browseState.selectedItems.length,
                        })
                      )
                    ),
                  ]),
                ],
                1
              ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-textarea", {
                    attrs: { label: _vm.$ct("archive-message"), fancy: "" },
                    model: {
                      value: _vm.message,
                      callback: function ($$v) {
                        _vm.message = $$v
                      },
                      expression: "message",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.create()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }